import { IDENTITY_VALIDATION_OK } from '../utils/registration.constants';
import { LEAD_EVENT_STAGES } from '../../constants/leadEventStages';
import { IS_BR } from '../utils/registrationConfig';
import {
  normalizeCpfForApi,
  normalizeRutForApi,
} from '../utils/identityDocument';
import { mapVehicleTypeToApi } from './vehicleType.mapper';

export function mapBasicProfilePayload(formData) {
  return {
    stage: LEAD_EVENT_STAGES.BASIC_PROFILE,
    content: {
      first_name: formData.first_name,
      last_name: formData.last_name,
      phone: formData.phone,
      id_city: formData.id_city,
      id_region: formData.id_region,
    },
  };
}

export function mapPersonalDetailsPayload(formData) {
  const content = {
    identity_number: IS_BR
      ? normalizeCpfForApi(formData.cpf)
      : normalizeRutForApi(formData.rut),
    address: formData.address,
    birth_date: formData.birth_date
      ? formData.birth_date.format('YYYY-MM-DD')
      : null,
  };

  if (IS_BR) {
    content.address_detail = formData.neighborhood;
  }

  return {
    stage: LEAD_EVENT_STAGES.PERSONAL_DETAILS,
    content,
  };
}

export function mapVehicleInfoPayload(formData) {
  return {
    stage: LEAD_EVENT_STAGES.VEHICLE_INFO,
    content: {
      vehicle_type: mapVehicleTypeToApi(formData.vehicle_type),
      vehicle_brand: formData.brand,
      vehicle_model: formData.model,
      license_plate: formData.plate,
    },
  };
}

export function mapDriverLicensePayload(imageUrl) {
  return {
    stage: LEAD_EVENT_STAGES.DRIVER_LICENSE_UPLOAD,
    content: {
      driver_license: imageUrl,
    },
  };
}

export function mapIdentityValidationResponse(dto) {
  const message = dto?.message ?? '';
  return {
    valid: Boolean(message === IDENTITY_VALIDATION_OK),
    message,
  };
}
